module.exports = __webpack_public_path__ + "static/media/bgFHD.364587f2.jpg";